<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'titulacions', params: {page: $route.params.listPage || 1, sort: $route.params.listSort || 'titulacio_sigles asc'}}">{{$t('Titulacions')}}</router-link-locale></li>
        <li v-if="response.titulacio && response.titulacio[`titulacio_nom_${locale}`]" class="breadcrumb-item active" aria-current="page">{{ response.titulacio[`titulacio_nom_${locale}`] }}</li>
        <li v-else-if="response.titulacio" class="breadcrumb-item active" aria-current="page">{{ response.titulacio.titulacio_nom_ca }}</li>
      </ol>
    </nav>

    <h1 v-if="response.titulacio && response.titulacio[`titulacio_nom_${locale}`]">{{ response.titulacio[`titulacio_nom_${locale}`] }}</h1>
    <h1 v-else-if="response.titulacio">{{ response.titulacio.titulacio_nom_ca }}</h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.titulacio">

          <div class="card-body">

            <div class="m-t-20 row">
              <div class="col-md-2 col-xs-12 text-center mb-2">
                <i style="color: #5fa728;" class="fa fa-graduation-cap fa-8x mb-2"></i>
              </div>
              <div class="col-md-10">
                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nom')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.titulacio[`titulacio_nom_${locale}`] }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Sigles')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.titulacio.titulacio_sigles }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Activa')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <span v-if="response.titulacio.titulacio_activa" class="badge bg-success">{{ $t("true") }}</span>
                    <span v-else class="badge bg-danger">{{ $t("false") }}</span>
                  </div>
                </div>

                <hr>

                <div class="row mb-2" v-if="response.titulacio.titulacio_centre">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centre')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">

                      <router-link :to="{name: 'organitzacio', params: {id: response.titulacio.titulacio_centre}}">{{ $t(response.titulacio.titulacio_centre) }}</router-link>

                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Pla')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.titulacio.titulacio_pla }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nivell')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.titulacio.titulacio_nivell }}
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <img src="../assets/images/mini-rss.svg" width="20" alt="user" class="me-1">
                  <a class="me-4" :href="'https://apren.upc.edu/api/RSS/' + response.titulacio.id" target="_blank" rel="noreferrer noopener">{{$t('RSS')}}</a>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <a @click='hideShowProfessorsFunction()' style="cursor:pointer;" class="text-secondary mr-1">
      <h2 class="mt-5">
        <i v-if="!hideShowProfessors" class="fa-regular fa-plus me-2"></i>
        <i v-if="hideShowProfessors" class="fa fa-minus me-2"></i>
        {{$t('participants')}}
      </h2>
    </a>

    <div v-if="hideShowProfessors">

      <div class="row">

        <div v-if="responseProfessors.length === 0" class="alert alert-danger rounded-0" role="alert">
          {{ $t("No results") }}
        </div>
        <div v-else class="col-sm-12 col-md-12">
          <ul class="list-unstyled" style="column-count: 4;">
            <!-- class="list-group-item list-group-item-action" style="border-bottom: none; border-top: none ; border-right: none; border-left: none;"-->
            <router-link v-for="(professor) in responseProfessors.professors" :key="professor.id" :to="{name: 'professor', params: {id: professor.id}}">
              <li class="mb-3"><i class="fas fa-user mr-2 text-secondary"></i> {{professor.professor_nom}} ({{professor.professor_num_activitats}})</li>
            </router-link>
          </ul>
        </div>

      </div>
    </div>

    <div class="row mt-4">
      <MaterialsCommon :init-query="initQuery" router-name="titulacio"></MaterialsCommon>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import {
  getProfessorsParticipantsTitulacio
} from "@/composables/pageFunctions";
import { useI18n } from 'vue-i18n';
import {setMetadataName} from "@/composables/metadataFunctions";
import TitulacioService from "@/services/TitulacioService";
import MaterialsCommon from "@/components/MaterialsCommon.vue";

  export default {
    name: "TitulacioView",
    components: {
      MaterialsCommon,
      RouterLinkLocale},

    setup() {
      const { locale } = useI18n();

      const response = ref([]);
      const responseMaterials = ref([]);
      const responseProfessors = ref([]);
      const route = useRoute();

      const initQuery = computed(() => {
        const id = route.params.id;
        return `activitat_titulacions:${id}`;
      });

      const hideShowProfessors = ref(false)

      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Titulació");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-red.webp') });
        const id = route.params.id;
        response.value = await TitulacioService.getTitulacio(id)
        setMetadataName(response.value.titulacio[`titulacio_nom_${locale.value}`])
      });

      const hideShowProfessorsFunction = async () => {
        if(responseProfessors.value.length === 0){
          responseProfessors.value = await getProfessorsParticipantsTitulacio(response.value.titulacio.id)
        }
        hideShowProfessors.value = !hideShowProfessors.value
      };


      return {
        response,
        responseMaterials,
        responseProfessors,
        locale,
        initQuery,

        hideShowProfessors,
        hideShowProfessorsFunction
      }

    }

  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
